<template>
    <div class="site-flex">
        <navbar v-if="isLoggedIn"></navbar>
        <router-view class="full-height"></router-view>
        <heat-footer></heat-footer>
        <vue-cookie-accept-decline
            v-if="inEU()"
            :elementId="'heat-tracking'"
            :debug="false"
            :position="'bottom-right'"
            :type="'floating'"
            :transitionName="'slideFromBottom'"
            @clicked-accept="cookieClickedAccept">
            <div slot="declineContent" class="has-text-danger">
               Opt out
            </div>
            <div slot="acceptContent" class="has-text-info">
                I Accept
            </div>
        </vue-cookie-accept-decline>
    </div>
</template>

<script>
    import inEU from '@segment/in-eu'
    import {mapGetters} from "vuex";
    import HeatFooter from "heat-shared/src/components/HeatFooter";
    import VueCookieAcceptDecline from 'vue-cookie-accept-decline/src/vue-cookie-accept-decline'
    import Navbar from "./components/Navbar";
    import urls from "./urls"

    export default {
        name: "App",
        components: {Navbar, HeatFooter, VueCookieAcceptDecline},
        mixins: [urls],
        computed: {
            ...mapGetters('user', [
                'isLoggedIn',
            ]),
        },
        methods: {
            cookieClickedAccept() {
                this.$ga.enable();
                this.$ga.page(this.$router);
            },
            inEU(){
                return inEU();
            }
        }
    }
</script>

<style scoped>

</style>